import axios from "axios";
import { respuestaMockeada } from "@/mock";

const environment = _BBVA_AMBIENTE || "production";

const om = {
  /**
   * Realizar request genérica a la API
   * @param {Object} payload payload para el endpoint
   */
  request({ endPoint, body, mock }) {
    if (mock && environment !== "production") {
      return respuestaMockeada(endPoint, body, mock);
    }
    // Siempre retornar la promesa de axios
    return axios.post(endPoint, body);
  },
  get(endPoint, params, mock, headers) {
    if (mock && environment !== "production") {
      return respuestaMockeada(endPoint, params, mock);
    }
    const config = { params };
    if (headers) config.headers = headers;
    return axios.get(endPoint, config);
  }
};

export default om;
